module.exports = __webpack_public_path__ + "img/draw-mb.89e6a5fb.webp";